import React, { Component } from "react";
import Select from "react-select";
import { withRequest } from "../../../utils/request";
import { auth } from "../../../utils/auth";
import { apiUrl } from "../../../utils/apiUrl";
import Loader from "../../general/Loader";
import { toast } from "../../../utils/helpers";
import dayjs from "dayjs";

class AusenciasForm extends Component {
    state = {
        empleados: [],
        empleadosIds: [],
        errors: {},
        saving: false
    };

    componentDidMount() {
        this.getTable("empleados", "?estado=activos");

        if (this.props.empleado) {
            this.setState({ empleadoId: this.props.empleado.id });
        }
    }

    createAusencia = async event => {
        event.preventDefault();

        this.setState({
            saving: true
        });

        const token = auth.getToken();
        const data = new FormData(event.target);

        const url = `empleados/ausencias/crear`;

        const res = await fetch(apiUrl(url), {
            method: "post",
            body: data,
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token
            }
        });

        const response = await res.json();

        if (response.success) {
            if (this.props.getAusencias) {
                this.props.getAusencias();
            }
            document.getElementById("ausenciasform").reset();
            this.props.toggle();
            toast("Ausencia creada exitosamente.");
        }
        if (response.code === 422) {
            this.setState({ errors: response.data.message });
        }

        this.setState({
            saving: false
        });
    };

    getTable = async (url = null, params = "") => {
        const table = await this.props.request(url + params);

        if (table.data && table.data.length > 0) {
            this.setState({
                [url]: table.data
            });
        }
    };

    onChangeEmpleado = values => {
        if (values) {
            this.setState({
                empleadosIds: values.map((i) => i.value)
            });
        } else {
            this.setState({
                empleadosIds: []
            });
        }
    };

    render() {
        const { empleado, fecha } = this.props;
        const { empleados, empleadosIds, errors } = this.state;
        return (
            <form
                id='ausenciasform'
                method='post'
                onSubmit={this.createAusencia}>
                <input type='hidden' name='_method' value='post' />
                <div className='popup__header'>Crear Ausencia</div>
                <div className='popup__body'>
                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>
                                Empleados:
                            </label>
                        </div>
                        <div className='col col-md-8'>
                            <input
                                type='hidden'
                                name='empleados'
                                value={empleadosIds.join(",")}
                            />
                            <Select
                                name='empleado_id'
                                isClearable={true}
                                onChange={this.onChangeEmpleado}
                                isMulti
                                defaultValue={
                                    empleado.id && {
                                        isFixed: true,
                                        value: empleado.id,
                                        label: empleado.nombreCompleto
                                    }
                                }
                                options={empleados.map(empleado => ({
                                    value: empleado.id,
                                    label: empleado.nombreCompleto
                                }))}
                            />
                            {errors.empleados && (
                                <small className='help-blockParams form-Text'>
                                    {errors.empleados[0]}
                                </small>
                            )}
                        </div>
                    </div>

                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>
                                Fecha:
                            </label>
                        </div>
                        <div className='col col-md-8'>
                            <input
                                type='date'
                                name='fecha'
                                defaultValue={fecha ?? dayjs().format("YYYY-MM-DD")}
                                className='form-control'
                            />
                        </div>
                        {errors.fecha && (
                            <small className='help-blockParams form-Text'>
                                {errors.fecha[0]}
                            </small>
                        )}
                    </div>
                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>
                                Descripción:
                            </label>
                        </div>
                        <div className='col col-md-8'>
                            <textarea
                                type='text'
                                name='descripcion'
                                rows='5'
                                className='form-control'
                            />
                            {errors.descripcion && (
                                <small className='help-blockParams form-Text'>
                                    {errors.descripcion[0]}
                                </small>
                            )}
                        </div>
                    </div>
                </div>
                <div className='popup__footer'>
                    <button
                        type='button'
                        onClick={this.props.toggle}
                        className='btn btn-plain'>
                        Cancelar
                    </button>
                    {this.state.saving ? (
                        <Loader type='small' />
                    ) : (
                        <button type='submit' className='btn btn-primary'>
                            Crear
                        </button>
                    )}
                </div>
            </form>
        );
    }
}

export default withRequest(AusenciasForm);
